import { TranslatableObjectKey } from 'hooks/redux/Translatable/useTranslatableLanguages';

const defaultState = {
  mealTypeIngredientsSum: null,
  availableInVariableOffer: true,
  isAvailableInFixedOffer: false,
  isSubmitting: false,
  isLoading: false,
  isAdvancedCreation: false,
  historyHidden: true,
  tags: [],
  clientTags: [],
  productionImageUrl: null,
  clientImageUrl: null,
  customerPortal: null,
  customerPortalUrl: null,
  pdfImage: null,
  pdfImageUrl: null,
  servingSuggestions: [],
  emptyMealTypeIngredients: [],
  diets: [],
  mealTypes: [],
  selectedIngredients: [],
  mealSizes: [],
  containers: [],
  ecoContainers: [],
  disabledTypes: [],
  editDishMenuPlanner: [],
  dishUniqueDiets: [],
  dishUniqueDatesDietsAndBrands: [],
  dish: {
    id: null,
    nameForClient: { [TranslatableObjectKey]: {} },
    nameForClientInitial: { [TranslatableObjectKey]: {} },
    clientTags: [],
    tags: [],
    kwgGroups: [],
    productionImage: null,
    clientImage: null,
    servingSuggestion: null,
    note: '',
    sizes: [],
    preparingInstructions: '',
    rateAVG: 0,
    rate: 0,
    tips: '',
    preparingEstimatedMinutes: 60,
    types: [],
    categories: [],
    brands: [],
    excludedFromDiscountCodes: false,
    clientVat: null,
    shouldRescale: false,
  },
};

export default defaultState;
